import { createCanvas } from '@/utils/canvasUtils';
import { isImagePatternMember, sharedMaskCanvas } from '@/utils/imagePatternMasks';

fabric.MaskedImage = fabric.util.createClass(fabric.Image, {
    type: 'masked-image',

    cacheProperties: fabric.Group.prototype.cacheProperties.concat(
        'maskElement',
        'maskScaleX',
        'maskScaleY',
        'maskAngle',
        'maskOffsetX',
        'maskOffsetY',
        'maskHeight',
        'maskWidth'
    ),

    maskElement: null,
    maskScaleX: 1,
    maskScaleY: 1,
    maskAngle: 0,
    maskOffsetX: 0,
    maskOffsetY: 0,

    maskHeight: 0,
    maskWidth: 0,

    _maskCanvas: null,

    /**
     * Constructor
     * @param {HTMLImageElement | String} element Image element
     * @param {Object} [options] Options object
     * @param {function} [callback] callback function to call after eventual filters applied.
     * @return {fabric.Image} thisArg
     */
    initialize: function (element, options) {
        this.callSuper('initialize', element, options);
    },

    _resizeMaskImage: function (width, height) {
        const shareable = isImagePatternMember(this.group);
        // _set drops _maskCanvas whenever the mask or its size change, so a shared one is still current
        if (shareable && this._maskCanvas && this._maskCanvas === this._sharedMaskCanvas) return;

        if (!this._maskCanvas) {
            this._maskCanvas = document.createElement('canvas');
        }

        const canvas = this._maskCanvas;

        // Only resize if needed
        if ((canvas.width != width || canvas.height != height) && (width > 1 || height > 1)) {
            const shared =
                shareable &&
                sharedMaskCanvas(this.maskElement, String(this.maskingColor), width, height, () =>
                    this._buildMaskCanvas(document.createElement('canvas'), width, height)
                );
            if (shared) {
                this._maskCanvas = this._sharedMaskCanvas = shared;
                return;
            }
            this._buildMaskCanvas(canvas, width, height);
        }
    },

    _buildMaskCanvas: function (canvas, width, height) {
        const ctx = canvas.getContext('2d');
        const colorComponents = new fabric.Color(this.maskingColor).getSource();

        // Draw the mask image
        canvas.width = width;
        canvas.height = height;
        ctx.drawImage(this.maskElement, 0, 0, canvas.width, canvas.height);

        const imgData = ctx.getImageData(0, 0, canvas.width, canvas.height);
        const data = imgData.data;
        const length = data.length;
        const tolerance = 60;

        for (var n = 0; n < length; n += 4) {
            // If this is not the masking color, make the pixel transparent
            if (
                Math.abs(data[n] - colorComponents[0]) > tolerance ||
                Math.abs(data[n + 1] - colorComponents[1]) > tolerance ||
                Math.abs(data[n + 2] - colorComponents[2]) > tolerance ||
                Math.abs(data[n + 3] - 255) > tolerance
            ) {
                data[n + 3] = 0;
            }
        }

        ctx.putImageData(imgData, 0, 0);
        return canvas;
    },

    _set: function (key, value) {
        if (key === 'maskElement' || key === 'maskHeight' || key === 'maskWidth') {
            // Invalidate mask canvas so it's regenerated
            this._maskCanvas = null;

            // Make sure we have valid width/height values
            if (key === 'maskHeight' || key === 'maskWidth') {
                if (Number.isNaN(value) || !Number.isFinite(value)) {
                    value = 1;
                }
            }
        }

        this.callSuper('_set', key, value);
    },

    _getCacheCanvasDimensions: function () {
        var dims = this.callSuper('_getCacheCanvasDimensions');
        var clip = this.clipPath;
        if (!clip) {
            return dims;
        }

        var objScale = this.getObjectScaling();
        var dim = this._getTransformedDimensions(0, 0);
        if (!objScale.scaleX || !objScale.scaleY || !dim.x || !dim.y) {
            return dims;
        }

        var clipLocalX = (clip.width * Math.abs(clip.scaleX)) / objScale.scaleX;
        var clipLocalY = (clip.height * Math.abs(clip.scaleY)) / objScale.scaleY;

        if (clipLocalX > dim.x) {
            var fx = clipLocalX / dim.x;
            dims.width *= fx;
            dims.x *= fx;
        }
        if (clipLocalY > dim.y) {
            var fy = clipLocalY / dim.y;
            dims.height *= fy;
            dims.y *= fy;
        }

        return dims;
    },

    /**
     * @private
     * @param {CanvasRenderingContext2D} ctx Context to render on
     */
    _render: function (ctx) {
        // Apply mask. Don't use ctx.canvas.[width|height] to get canvas dimensions, for some reason they are much smaller
        //  (not even the cache canvas size dimensions) than the real canvas where the ctx belongs to, use this.[width|height]
        //  instead!
        if (this.maskElement) {
            // Make sure the mask has the required size
            this._resizeMaskImage(this.maskWidth, this.maskHeight);

            // Draw the image with the offset, rotation and scaling needed
            ctx.save();
            ctx.translate(this.maskOffsetX, this.maskOffsetY);
            ctx.rotate((this.maskAngle * Math.PI) / 180);
            ctx.scale(this.maskScaleX, this.maskScaleY);

            ctx.drawImage(this._element, -this.width / 2, -this.height / 2);
            ctx.restore();

            // Draw the mask over the image (center it too)
            ctx.globalCompositeOperation = 'destination-in';
            const offsetY = -this._maskCanvas.height / 2;
            const offsetX = -this._maskCanvas.width / 2;
            ctx.drawImage(this._maskCanvas, offsetX, offsetY);
        } else if (this.group && this.group.originalMaskSvg) {
            ctx.save();
            ctx.translate(this.maskOffsetX, this.maskOffsetY);
            ctx.rotate((this.maskAngle * Math.PI) / 180);
            ctx.drawImage(this._element, -this.width / 2, -this.height / 2);
            ctx.restore();
        } else {
            // Render the image normally
            this.callSuper('_render', ctx);
        }
    }
});
